import '.d{display:flex;}.ssr-plugin'
import '.a7{flex-direction:row;}.ssr-plugin'
import '.a8{background-color:var(--palette-white);}.ssr-plugin'
import '.ah{flex-grow:1;}.ssr-plugin'
import '.y{align-items:center;}.ssr-plugin'
import '.z{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.em{min-height:calc(100vh - 12rem);}.ssr-plugin'
import '.a4{align-items:stretch;}.ssr-plugin'
import '.en{margin-top:2rem;}.ssr-plugin'
import '.a3{margin-bottom:5rem;}.ssr-plugin'
import '.ai{max-width:77.5rem;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { InitiativeSideBar } from '@app/components/blocks/sidebar/InitiativeSideBar'
import { ClientOnly } from '@based/sdk/react'

export const InitiativeViewPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <div className="d a7 a8"
      >
        <InitiativeSideBar />
        <div className="ah d y z e"
          style={{
            marginLeft: isMobile ? '3.25rem' : '14rem', // left bar
          }}
        >
          <DashboardNavBar
            initiativeDashboard={true}
            style={{ backgroundColor: 'var(--palette-white)' }}
          />
          <div className="em d e a4 en a3 ai"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '60%', // 12rem is padding + navbar height
              paddingInline: isMobile ? '1rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
